var _defs, _path, _g, _g2, _path2, _path3, _path4, _path5, _path6, _polygon, _path7, _g3, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _polygon2, _polygon3, _polygon4, _path16, _path17, _path18, _path19, _path20, _path21, _polygon5, _polygon6, _polygon7, _polygon8, _polygon9, _polygon10, _polygon11, _polygon12, _polygon13, _polygon14, _polygon15, _polygon16, _polygon17, _polygon18, _polygon19, _polygon20, _polygon21, _polygon22, _polygon23, _polygon24, _polygon25, _polygon26, _polygon27, _polygon28, _polygon29, _polygon30, _polygon31, _polygon32, _polygon33, _polygon34, _polygon35, _polygon36, _polygon37, _polygon38, _polygon39, _polygon40, _polygon41, _polygon42, _polygon43, _polygon44, _polygon45, _polygon46, _polygon47, _polygon48, _polygon49, _polygon50, _polygon51, _polygon52, _polygon53, _polygon54, _polygon55, _polygon56, _polygon57, _polygon58, _polygon59, _polygon60, _polygon61, _polygon62, _polygon63, _polygon64, _polygon65, _polygon66, _polygon67, _polygon68, _polygon69, _polygon70, _polygon71, _polygon72, _polygon73, _polygon74, _polygon75, _polygon76, _polygon77, _polygon78, _polygon79, _polygon80, _polygon81, _polygon82, _polygon83, _polygon84, _polygon85, _polygon86, _polygon87, _polygon88, _polygon89, _polygon90, _polygon91, _polygon92, _polygon93, _polygon94, _polygon95, _path22, _path23, _path24, _polygon96, _polygon97, _polygon98, _polygon99, _polygon100, _polygon101, _path25, _path26, _path27, _path28, _path29, _path30, _polygon102, _polygon103, _polygon104, _path31, _path32, _path33, _polygon105, _polygon106, _polygon107, _polygon108, _polygon109, _polygon110, _polygon111, _polygon112, _polygon113, _polygon114, _polygon115, _polygon116, _polygon117, _polygon118, _polygon119, _polygon120, _polygon121, _polygon122, _path34, _polygon123, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _polygon124, _polygon125, _path52, _path53, _polygon126, _polygon127, _polygon128, _polygon129, _polygon130, _polygon131, _polygon132, _polygon133, _polygon134, _polygon135, _polygon136, _polygon137, _polygon138, _polygon139, _polygon140, _polygon141, _polygon142, _polygon143, _polygon144, _polygon145, _polygon146, _polygon147, _polygon148, _polygon149, _polygon150, _polygon151, _polygon152, _polygon153, _polygon154, _polygon155, _polygon156, _polygon157, _polygon158, _polygon159, _polygon160, _polygon161, _polygon162, _polygon163, _polygon164, _polygon165, _polygon166, _polygon167, _polygon168, _polygon169, _polygon170, _polygon171, _polygon172, _polygon173, _polygon174, _polygon175, _polygon176, _polygon177, _polygon178, _polygon179, _polygon180, _polygon181, _polygon182, _polygon183, _polygon184, _polygon185, _polygon186, _polygon187, _polygon188, _polygon189, _polygon190, _polygon191, _polygon192, _polygon193, _polygon194, _polygon195, _polygon196, _polygon197, _polygon198, _polygon199, _polygon200, _polygon201, _polygon202, _polygon203, _polygon204, _polygon205, _polygon206, _polygon207, _polygon208, _polygon209, _polygon210, _polygon211, _polygon212, _polygon213, _polygon214, _polygon215, _polygon216, _polygon217, _polygon218, _polygon219, _polygon220, _polygon221, _polygon222, _polygon223, _polygon224, _polygon225, _polygon226, _polygon227, _polygon228, _polygon229, _polygon230, _polygon231, _polygon232, _polygon233, _polygon234, _polygon235, _polygon236, _polygon237, _polygon238, _polygon239, _polygon240, _polygon241, _polygon242, _polygon243, _polygon244, _polygon245, _polygon246, _polygon247, _polygon248, _polygon249, _polygon250, _polygon251, _polygon252, _polygon253, _polygon254, _polygon255, _polygon256, _polygon257, _polygon258, _polygon259, _polygon260, _polygon261, _polygon262, _polygon263, _polygon264, _polygon265, _polygon266, _polygon267, _polygon268, _polygon269, _polygon270, _polygon271, _polygon272, _polygon273, _polygon274, _polygon275, _polygon276, _polygon277, _polygon278, _polygon279, _polygon280, _polygon281, _polygon282, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _g4, _g5, _path66, _polygon283, _polygon284, _polygon285, _polygon286, _polygon287, _polygon288, _polygon289, _polygon290, _polygon291, _polygon292, _polygon293, _polygon294, _polygon295, _polygon296, _polygon297, _polygon298, _polygon299, _polygon300, _polygon301, _polygon302, _polygon303, _path67, _path68, _path69, _path70, _path71, _path72, _ellipse, _ellipse2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDenim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 271.75 233.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #50e85e;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #edf0f8;\n      }\n\n      .cls-3 {\n        fill: #fcec32;\n      }\n\n      .cls-4 {\n        fill: #8444b2;\n      }\n\n      .cls-5 {\n        fill: #de64c6;\n      }\n\n      .cls-6 {\n        fill: #2a87c6;\n      }\n\n      .cls-7 {\n        fill: #5c5d60;\n      }\n\n      .cls-8 {\n        fill: #d8395a;\n      }\n\n      .cls-9 {\n        fill: #1c75bc;\n      }\n\n      .cls-10 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-11 {\n        fill: #ef4136;\n      }\n\n      .cls-12 {\n        isolation: isolate;\n        opacity: .2;\n      }\n\n      .cls-12, .cls-38 {\n        fill: #fff;\n      }\n\n      .cls-13 {\n        fill: #1f5e77;\n      }\n\n      .cls-14 {\n        fill: #0b3b56;\n      }\n\n      .cls-15 {\n        fill: #56a8dd;\n      }\n\n      .cls-16 {\n        fill: #fffbf0;\n      }\n\n      .cls-17 {\n        fill: #eaa10c;\n      }\n\n      .cls-18 {\n        fill: #fed4bd;\n      }\n\n      .cls-19 {\n        fill: #e8ebf5;\n      }\n\n      .cls-20 {\n        fill: #ffa8e1;\n      }\n\n      .cls-21 {\n        fill: #79ff68;\n      }\n\n      .cls-22 {\n        fill: #ed5561;\n      }\n\n      .cls-23 {\n        fill: #dfbab8;\n      }\n\n      .cls-24 {\n        fill: #f5d012;\n      }\n\n      .cls-25 {\n        fill: #f4c5a2;\n      }\n\n      .cls-26 {\n        fill: #411;\n      }\n\n      .cls-27 {\n        fill: #faa957;\n      }\n\n      .cls-28 {\n        fill: #a7bcce;\n      }\n\n      .cls-29 {\n        fill: #f5ddd8;\n      }\n\n      .cls-30 {\n        fill: #ff7ad2;\n      }\n\n      .cls-31 {\n        fill: #9d4d36;\n      }\n\n      .cls-32 {\n        fill: #f4767a;\n      }\n\n      .cls-42 {\n        opacity: .4;\n      }\n\n      .cls-33 {\n        fill: #9263c1;\n      }\n\n      .cls-34 {\n        fill: #7231a3;\n      }\n\n      .cls-35 {\n        fill: #f0cec9;\n      }\n\n      .cls-36 {\n        fill: #07304b;\n      }\n\n      .cls-37 {\n        fill: #3cc743;\n      }\n\n      .cls-39 {\n        fill: #231f20;\n      }\n\n      .cls-40 {\n        fill: #bbcee1;\n      }\n\n      .cls-41 {\n        fill: #0f4463;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 113.94,
    y1: 103.56,
    x2: 131.21,
    y2: 160.36,
    gradientTransform: "translate(0 236) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1c75bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2077bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#2b7ebc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#3e88bc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5394bc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M76.01,201.27c2.11.26,4.23.51,6.34.77.66-8.72,1.33-17.43,1.99-26.15l-8.71,3.01c-.12,1.96-.2,3.99-.23,6.07-.07,5.67.25,10.95.8,15.76-.07.18-.13.36-.2.54Z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "139.48 28.51 139.48 29.58 143.98 32.17 143.98 31.1 139.48 28.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "139.48 30.46 139.48 31.54 143.98 34.13 143.98 33.06 139.48 30.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "139.48 32.42 139.48 33.49 143.98 36.09 143.98 35.01 139.48 32.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "173.42 55.02 173.42 53.95 145.67 37.94 145.67 39.01 173.42 55.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "139.48 34.38 139.48 35.45 143.98 38.04 143.98 36.97 139.48 34.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "139.48 36.33 139.48 37.4 143.98 40 143.98 38.92 139.48 36.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "173.42 56.98 173.42 55.91 145.67 39.9 145.67 40.97 173.42 56.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "139.48 42.2 139.48 43.27 143.98 45.86 143.98 44.79 139.48 42.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "139.48 44.15 139.48 45.22 143.98 47.82 143.98 46.75 139.48 44.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "139.48 51.98 139.48 53.05 143.98 55.64 143.98 54.57 139.48 51.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "139.48 53.93 139.48 55 143.98 57.59 143.98 56.52 139.48 53.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "163.17 67.6 145.67 57.5 145.67 58.57 163.17 68.67 163.17 67.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "164.1 68.13 164.1 69.2 173.42 74.58 173.42 73.51 164.1 68.13"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "154.46 60.62 145.67 55.54 145.67 56.61 154.46 61.69 154.46 60.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "155.39 61.15 155.39 62.22 173.42 72.62 173.42 71.55 155.39 61.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "171.05 64.32 171.05 65.39 173.42 66.75 173.42 65.68 171.05 64.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "158.14 54.91 145.67 47.72 145.67 48.79 158.14 55.98 158.14 54.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "153.03 36.32 145.67 32.08 145.67 33.15 153.03 37.39 153.03 36.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "165.09 43.28 153.95 36.85 153.95 37.92 165.09 44.35 165.09 43.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "158.6 41.49 150.75 36.97 150.75 38.04 158.6 42.56 158.6 41.49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "166.83 46.24 159.52 42.02 159.52 43.09 166.83 47.31 166.83 46.24"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "167.75 46.77 167.75 47.84 173.42 51.11 173.42 50.04 167.75 46.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "147.12 36.82 147.12 37.89 153.03 41.3 153.03 40.23 147.12 36.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "171.11 50.66 153.95 40.77 153.95 41.84 171.11 51.73 171.11 50.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "161.28 50.86 150.07 44.4 150.07 45.47 161.28 51.93 161.28 50.86"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "171.11 56.53 162.21 51.4 162.21 52.47 171.11 57.6 171.11 56.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "170.12 61.83 159.06 55.45 159.06 56.52 170.12 62.9 170.12 61.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "164.1 60.31 164.1 61.38 170.12 64.85 170.12 63.78 164.1 60.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "147.84 50.93 145.67 49.68 145.67 50.75 147.84 52 147.84 50.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "151.9 53.27 151.9 54.34 163.17 60.84 163.17 59.77 151.9 53.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "150.98 52.74 148.76 51.46 148.76 52.53 150.98 53.81 150.98 52.74"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "161.09 60.53 148.76 53.42 148.76 54.49 161.09 61.6 161.09 60.53"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "163.46 10.8 144.81 0 144.81 .95 163.46 11.75 163.46 10.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "144.81 2.81 173.42 19.36 173.42 18.41 144.81 1.86 144.81 2.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "164.71 11.5 164.71 12.45 173.42 17.5 173.42 16.55 164.71 11.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "163.46 14.43 144.81 3.63 144.81 4.58 163.46 15.38 163.46 14.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "144.81 6.45 173.42 22.99 173.42 22.04 144.81 5.5 144.81 6.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "164.71 16.08 173.42 21.13 173.42 20.18 164.71 15.14 164.71 16.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "163.46 20.43 144.81 9.63 144.81 10.58 163.46 21.38 163.46 20.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "144.81 12.45 173.42 28.99 173.42 28.04 144.81 11.5 144.81 12.45"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "164.71 22.08 173.42 27.13 173.42 26.18 164.71 21.14 164.71 22.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "163.46 24.07 144.81 13.27 144.81 14.22 163.46 25.02 163.46 24.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "144.81 16.08 173.42 32.63 173.42 31.68 144.81 15.13 144.81 16.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "164.71 25.72 173.42 30.76 173.42 29.82 164.71 24.77 164.71 25.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "163.46 30.07 144.81 19.27 144.81 20.22 163.46 31.02 163.46 30.07"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "144.81 22.08 173.42 38.63 173.42 37.68 144.81 21.13 144.81 22.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "164.71 31.72 173.42 36.76 173.42 35.81 164.71 30.77 164.71 31.72"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "163.46 33.7 144.81 22.9 144.81 23.85 163.46 34.65 163.46 33.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "144.81 25.71 173.42 42.26 173.42 41.31 144.81 24.76 144.81 25.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "164.71 35.35 173.42 40.4 173.42 39.45 164.71 34.4 164.71 35.35"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M113.15,24.41l-13.93-8c-.47-.29-1.09-.15-1.38.32-.11.17-.16.36-.15.56v16.67c-.02.83.42,1.59,1.14,2l13.93,8.06c.46.31,1.08.19,1.39-.26.13-.19.19-.42.17-.65v-16.7c-.01-.83-.46-1.59-1.17-2Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M106.97,38.47l-18.26-10.53c-.57-.33-1.28-.31-1.83.07h0l-4,2.31,1.86,2.53.7.8v18.09c0,1.08.57,2.07,1.5,2.61l13.67,7.91.14.76,2.79,3.91,4.29-2.53h0c.41-.25.66-.69.66-1.17v-22c.02-1.13-.56-2.18-1.52-2.76Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M102.7,40.98l-18.46-10.66c-.65-.36-1.47-.12-1.83.53-.11.2-.16.41-.17.64v22.12c0,1.08.57,2.07,1.51,2.61l18.48,10.69c.67.38,1.52.15,1.9-.52.12-.21.18-.44.18-.68v-22c0-1.13-.62-2.18-1.61-2.73Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M104.24,65.71v-22c0-.36-.08-.72-.21-1.06l4.28-2.47c.12.32.19.66.2,1v22c0,.48-.25.92-.66,1.17h0l-4.25,2.5c.39-.25.64-.68.64-1.14Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M86.59,40.91l-2.25-1.3v8.09l1.49.86v-2.88l.64.37c.56.44,1.3.62,2,.48.47-.19.71-.72.71-1.59.02-.81-.21-1.6-.66-2.27-.49-.73-1.16-1.33-1.93-1.76ZM87.34,44.84c-.36.04-.72-.06-1-.28l-.49-.28v-2.4l.68.39c.36.2.66.47.89.81.2.31.3.68.29,1.05-.02.4-.14.64-.37.71Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "94.4 48.59 91.62 46.98 91.63 43.81 90.13 42.95 90.11 51.04 91.6 51.9 91.61 48.41 94.4 50.02 94.39 53.51 95.88 54.37 95.9 46.28 94.41 45.42 94.4 48.59"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M101.47,50.14c-.5-.73-1.16-1.34-1.94-1.76l-2.25-1.3v8.09l1.49.86v-2.87l.64.37c.57.44,1.3.61,2,.47.47-.19.71-.71.71-1.59.02-.81-.21-1.6-.65-2.27ZM100.24,52.32c-.36.04-.72-.07-1-.29l-.49-.28v-2.4l.68.39c.36.19.66.47.89.81.2.32.3.69.29,1.06.02.39-.1.63-.37.71Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "63.84 39.29 63.84 40.36 68.34 42.96 68.34 41.89 63.84 39.29"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "63.84 41.25 63.84 42.32 68.34 44.91 68.34 43.84 63.84 41.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "63.84 43.2 63.84 44.27 68.34 46.87 68.34 45.8 63.84 43.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "97.78 65.8 97.78 64.73 70.03 48.73 70.03 49.8 97.78 65.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "63.84 45.16 63.84 46.23 68.34 48.82 68.34 47.75 63.84 45.16"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "63.84 47.11 63.84 48.19 68.34 50.78 68.34 49.71 63.84 47.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "97.78 67.76 97.78 66.69 70.03 50.68 70.03 51.75 97.78 67.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "63.84 52.98 63.84 54.05 68.34 56.65 68.34 55.58 63.84 52.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "63.84 54.94 63.84 56.01 68.34 58.6 68.34 57.53 63.84 54.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "63.84 62.76 63.84 63.83 68.34 66.42 68.34 65.35 63.84 62.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "63.84 64.71 63.84 65.78 68.34 68.38 68.34 67.31 63.84 64.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "87.53 78.38 70.03 68.28 70.03 69.35 87.53 79.45 87.53 78.38"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "88.46 78.91 88.46 79.98 97.78 85.36 97.78 84.29 88.46 78.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "78.82 71.4 70.03 66.33 70.03 67.4 78.82 72.47 78.82 71.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "79.74 71.93 79.74 73 97.78 83.4 97.78 82.33 79.74 71.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "95.41 75.1 95.41 76.17 97.78 77.54 97.78 76.47 95.41 75.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "82.49 65.7 70.03 58.5 70.03 59.57 82.49 66.77 82.49 65.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "77.39 47.1 70.03 42.86 70.03 43.93 77.39 48.17 77.39 47.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "89.45 54.06 78.31 47.64 78.31 48.71 89.45 55.13 89.45 54.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "82.96 52.27 75.11 47.75 75.11 48.82 82.96 53.34 82.96 52.27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "91.19 57.02 83.88 52.81 83.88 53.88 91.19 58.09 91.19 57.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "92.11 57.55 92.11 58.62 97.78 61.89 97.78 60.82 92.11 57.55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "71.48 47.61 71.48 48.68 77.39 52.09 77.39 51.02 71.48 47.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "95.47 61.44 78.31 51.55 78.31 52.62 95.47 62.52 95.47 61.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "85.64 61.65 74.43 55.18 74.43 56.25 85.64 62.72 85.64 61.65"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "95.47 67.31 86.57 62.18 86.57 63.25 95.47 68.38 95.47 67.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "94.48 72.61 83.42 66.23 83.42 67.3 94.48 73.68 94.48 72.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "88.46 71.09 88.46 72.16 94.48 75.64 94.48 74.57 88.46 71.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "72.2 61.71 70.03 60.46 70.03 61.53 72.2 62.78 72.2 61.71"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "76.26 64.06 76.26 65.13 87.53 71.63 87.53 70.56 76.26 64.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "75.34 63.52 73.12 62.24 73.12 63.31 75.34 64.59 75.34 63.52"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "85.45 71.31 73.12 64.2 73.12 65.27 85.45 72.38 85.45 71.31"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M197.94,53.21l-13.93-8c-.47-.29-1.09-.15-1.38.32-.11.17-.16.37-.15.57v16.67c-.01.82.42,1.59,1.13,2l13.93,8.05c.45.32,1.08.21,1.39-.25.13-.19.2-.42.18-.65v-16.68c0-.84-.45-1.61-1.17-2.03Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M216.96,20.99l-13.93-8c-.47-.29-1.09-.15-1.38.32-.11.17-.16.36-.15.56v16.64c-.02.83.42,1.59,1.14,2l13.93,8.06c.46.31,1.08.19,1.39-.26.13-.19.19-.42.17-.65v-16.6c.02-.85-.43-1.65-1.17-2.07Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M259.97,108.17l-13.93-8c-.47-.29-1.09-.15-1.38.32-.11.17-.16.36-.15.56v16.68c-.02.83.42,1.59,1.14,2l13.92,8.06c.45.32,1.08.21,1.39-.24.14-.19.2-.43.18-.67v-16.6c.04-.87-.42-1.68-1.17-2.11Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M138.72,67.14l-13.93-8c-.47-.29-1.09-.14-1.37.33-.1.17-.15.36-.15.56v16.67c-.01.82.42,1.59,1.13,2l13.93,8.05c.45.32,1.08.21,1.39-.25.13-.19.2-.42.18-.65v-16.68c0-.84-.45-1.61-1.18-2.03Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M86.29,204.17c-3.7,0-2.49-2.78-2.49-2.78-5.48-1.67-8.18-.74-8.18-.74-.29,2.98-.58,5.96-.87,8.94,0,.09.01.24.08.4.18.44.62.64.86.73,2.95,1.09,5.64,1.82,11.13,1.29,4.05-.4,8.33-4.14,7.36-8-.61-2.38-4.14.12-7.89.16Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M84.7,169.41c-1.08-1.41-2.94-2.61-6-1.8l-33.06,6.38,1.24,8.49c3.39,4.05,8.87,5.68,13.93,4.15,5.19-1.45,10.13-3.7,14.62-6.68l-.03,12.08c3.3.89,3.79-.69,6.79-2.33.77-.47,3.4-10.53,3.64-16.33.17-1.41-.24-2.84-1.13-3.95Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M92.57,207.57c2.11.26,4.23.51,6.34.77.66-8.72,1.33-17.43,1.99-26.15l-8.71,3.01c-.12,1.96-.2,3.99-.23,6.07-.07,5.67.25,10.95.8,15.76-.07.18-.13.36-.2.54Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M91.44,217.75c3.07,1.14,5.86,1.89,11.56,1.34,4.2-.41,8.65-4.3,7.64-8.3-.65-2.48-4.32.12-8.21.16-3.84,0-2.58-2.89-2.58-2.89-5.7-1.73-7.62-.95-7.62-.95"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "64.58 201.62 36.2 185.21 36.2 189.21 64.59 205.57 64.58 201.62"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "62 170.39 36.2 185.21 64.58 201.62 90.41 186.78 62 170.39"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "90.41 186.78 64.58 201.62 64.59 205.57 90.41 190.63 90.41 186.78"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M100.51,174.85c-1.12-1.46-3-2.71-6.25-1.87l-34.33,6.62,1.31,8.81c3.52,4.21,9.21,5.9,14.46,4.31,5.39-1.5,10.52-3.84,15.18-6.94.31,1.25.63,2.5.94,3.76l.56-1.14.5-1.01c.38.3.76.61,1.14.91.51-.78,1.02-1.56,1.52-2.35.83.77,1.65,1.54,2.48,2.31.56-1.35,1.13-2.7,1.69-4.05l1.72,2.11c.43-3.12.4-5.65.28-7.43-.11-1.6-.3-2.88-1.19-4.04Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M39.17,125.19l58.62-34c2.48-1.43,5.52-1.43,8,0l92.34,53.42c1.69.97,2.27,3.13,1.3,4.82-.31.54-.76.99-1.3,1.3l-57.31,33.27c-2.95,1.71-6.6,1.71-9.55,0l-92.13-53.3c-1.52-.86-2.05-2.79-1.18-4.31.29-.5.71-.92,1.21-1.2Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M39.18,130.67l92.13,53.3c2.95,1.71,6.6,1.71,9.55,0l57.31-33.27c1.08-.62,1.74-1.76,1.76-3v4.46h0c0,1.24-.67,2.38-1.75,3l-57.32,33.25c-2.95,1.71-6.6,1.71-9.55,0l-92.13-53.3c-.99-.57-1.6-1.63-1.59-2.77h0v-4.38c0,1.12.61,2.16,1.59,2.71Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M39.18,130.67l92.13,53.3c1.33.76,2.83,1.19,4.36,1.25v4.42c-1.53-.06-3.03-.49-4.36-1.25l-92.13-53.3c-.99-.57-1.6-1.63-1.59-2.77h0v-4.38c0,1.13.6,2.18,1.59,2.73Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M82.48,137.49l9.95-5.75c.47-.27,1.04-.27,1.51,0l30.73,17.77c.32.19.42.6.23.92-.06.09-.14.17-.23.23l-9.71,5.61c-.55.32-1.24.32-1.79,0l-30.69-17.74c-.29-.17-.39-.54-.22-.83.05-.09.13-.16.22-.21Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M82.48,138.53l30.69,17.74c.55.32,1.24.32,1.79,0l9.71-5.61c.21-.12.33-.34.33-.58v1.18h0c0,.23-.13.45-.33.57l-9.71,5.58c-.55.32-1.24.32-1.79,0l-30.69-17.7c-.19-.11-.3-.31-.29-.52h0v-1.18c0,.21.11.41.29.52Z"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "92.32 133.35 93.56 132.63 94.98 133.44 93.74 134.16 92.32 133.35"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "94.08 134.37 95.33 133.64 96.74 134.46 95.5 135.18 94.08 134.37"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "95.85 135.38 97.09 134.66 98.51 135.48 97.27 136.2 95.85 135.38"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "97.61 136.4 98.86 135.68 100.28 136.49 99.03 137.21 97.61 136.4"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "99.38 137.42 100.63 136.69 102.04 137.51 100.8 138.23 99.38 137.42"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "101.15 138.43 102.39 137.71 103.81 138.53 102.57 139.25 101.15 138.43"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "102.91 139.45 104.16 138.73 105.57 139.54 104.33 140.26 102.91 139.45"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "104.68 140.47 105.92 139.74 107.34 140.56 106.1 141.28 104.68 140.47"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "106.44 141.48 107.69 140.76 109.1 141.58 107.86 142.3 106.44 141.48"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "108.21 142.5 109.46 141.78 110.87 142.59 109.63 143.31 108.21 142.5"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "109.98 143.51 111.22 142.79 112.64 143.61 111.4 144.33 109.98 143.51"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "111.74 144.53 112.99 143.81 114.4 144.63 113.16 145.34 111.74 144.53"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "114.75 144.82 116.17 145.64 114.93 146.36 113.51 145.55 114.75 144.82"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "92.12 135.1 90.71 134.28 91.95 133.56 93.37 134.38 92.12 135.1"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "95.13 135.39 93.89 136.11 92.47 135.3 93.72 134.58 95.13 135.39"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "96.9 136.41 95.66 137.13 94.24 136.32 95.48 135.59 96.9 136.41"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "98.66 137.43 97.42 138.15 96 137.33 97.25 136.61 98.66 137.43"
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "100.43 138.44 99.19 139.16 97.77 138.35 99.01 137.63 100.43 138.44"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "102.2 139.46 100.95 140.18 99.53 139.37 100.78 138.64 102.2 139.46"
  })), _polygon24 || (_polygon24 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "103.96 140.48 102.72 141.2 101.3 140.38 102.55 139.66 103.96 140.48"
  })), _polygon25 || (_polygon25 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "105.73 141.49 104.49 142.21 103.07 141.4 104.31 140.68 105.73 141.49"
  })), _polygon26 || (_polygon26 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "107.49 142.51 106.25 143.23 104.83 142.42 106.08 141.69 107.49 142.51"
  })), _polygon27 || (_polygon27 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "109.26 143.53 108.02 144.25 106.6 143.43 107.84 142.71 109.26 143.53"
  })), _polygon28 || (_polygon28 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "111.03 144.54 109.78 145.26 108.36 144.45 109.61 143.73 111.03 144.54"
  })), _polygon29 || (_polygon29 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "112.79 145.56 111.55 146.28 110.13 145.47 111.37 144.74 112.79 145.56"
  })), _polygon30 || (_polygon30 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "113.14 145.76 114.56 146.57 113.32 147.3 111.9 146.48 113.14 145.76"
  })), _polygon31 || (_polygon31 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "90.51 136.03 89.09 135.22 90.34 134.5 91.75 135.31 90.51 136.03"
  })), _polygon32 || (_polygon32 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "93.52 136.33 92.28 137.05 90.86 136.23 92.1 135.51 93.52 136.33"
  })), _polygon33 || (_polygon33 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "92.62 137.25 93.87 136.53 95.29 137.34 94.04 138.06 92.62 137.25"
  })), _polygon34 || (_polygon34 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "97.05 138.36 95.81 139.08 94.39 138.27 95.64 137.54 97.05 138.36"
  })), _polygon35 || (_polygon35 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "98.82 139.38 97.58 140.1 96.16 139.28 97.4 138.56 98.82 139.38"
  })), _polygon36 || (_polygon36 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "100.58 140.39 99.34 141.11 97.92 140.3 99.17 139.58 100.58 140.39"
  })), _polygon37 || (_polygon37 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "102.35 141.41 101.11 142.13 99.69 141.32 100.93 140.59 102.35 141.41"
  })), _polygon38 || (_polygon38 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "104.12 142.43 102.87 143.15 101.45 142.33 102.7 141.61 104.12 142.43"
  })), _polygon39 || (_polygon39 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "105.88 143.44 104.64 144.16 103.22 143.35 104.47 142.63 105.88 143.44"
  })), _polygon40 || (_polygon40 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "107.65 144.46 106.41 145.18 104.99 144.37 106.23 143.64 107.65 144.46"
  })), _polygon41 || (_polygon41 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "109.41 145.48 108.17 146.2 106.75 145.38 108 144.66 109.41 145.48"
  })), _polygon42 || (_polygon42 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "108.52 146.4 109.76 145.68 111.18 146.49 109.94 147.21 108.52 146.4"
  })), _polygon43 || (_polygon43 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "111.53 146.69 112.95 147.51 111.7 148.23 110.28 147.41 111.53 146.69"
  })), _polygon44 || (_polygon44 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "88.9 136.97 87.48 136.15 88.73 135.43 90.14 136.25 88.9 136.97"
  })), _polygon45 || (_polygon45 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "89.25 137.17 90.49 136.44 91.91 137.26 90.67 137.98 89.25 137.17"
  })), _polygon46 || (_polygon46 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "91.01 138.18 92.26 137.46 93.67 138.28 92.43 139 91.01 138.18"
  })), _polygon47 || (_polygon47 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "92.78 139.2 94.03 138.48 95.44 139.29 94.2 140.01 92.78 139.2"
  })), _polygon48 || (_polygon48 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "94.54 140.22 95.79 139.49 97.21 140.31 95.96 141.03 94.54 140.22"
  })), _polygon49 || (_polygon49 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "96.31 141.23 97.56 140.51 98.97 141.33 97.73 142.05 96.31 141.23"
  })), _polygon50 || (_polygon50 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "98.08 142.25 99.32 141.53 100.74 142.34 99.5 143.06 98.08 142.25"
  })), _polygon51 || (_polygon51 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "99.84 143.27 101.09 142.54 102.5 143.36 101.26 144.08 99.84 143.27"
  })), _polygon52 || (_polygon52 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "101.61 144.28 102.85 143.56 104.27 144.38 103.03 145.1 101.61 144.28"
  })), _polygon53 || (_polygon53 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "103.37 145.3 104.62 144.58 106.04 145.39 104.79 146.11 103.37 145.3"
  })), _polygon54 || (_polygon54 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "105.14 146.32 106.39 145.59 107.8 146.41 106.56 147.13 105.14 146.32"
  })), _polygon55 || (_polygon55 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "106.91 147.33 108.15 146.61 109.57 147.43 108.33 148.15 106.91 147.33"
  })), _polygon56 || (_polygon56 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "109.92 147.63 111.33 148.44 110.09 149.16 108.67 148.35 109.92 147.63"
  })), _polygon57 || (_polygon57 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "87.29 137.9 85.87 137.09 87.12 136.36 88.53 137.18 87.29 137.9"
  })), _polygon58 || (_polygon58 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "87.63 138.1 88.88 137.38 90.3 138.19 89.06 138.91 87.63 138.1"
  })), _polygon59 || (_polygon59 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "89.4 139.12 90.65 138.4 92.06 139.21 90.82 139.93 89.4 139.12"
  })), _polygon60 || (_polygon60 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "91.17 140.13 92.41 139.41 93.83 140.23 92.59 140.95 91.17 140.13"
  })), _polygon61 || (_polygon61 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "92.93 141.15 94.18 140.43 95.59 141.25 94.35 141.97 92.93 141.15"
  })), _polygon62 || (_polygon62 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "94.7 142.17 95.95 141.44 97.36 142.26 96.12 142.98 94.7 142.17"
  })), _polygon63 || (_polygon63 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "96.46 143.18 97.71 142.46 99.13 143.28 97.88 144 96.46 143.18"
  })), _polygon64 || (_polygon64 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "98.23 144.2 99.48 143.48 100.89 144.29 99.65 145.01 98.23 144.2"
  })), _polygon65 || (_polygon65 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "100 145.22 101.24 144.49 102.66 145.31 101.42 146.03 100 145.22"
  })), _polygon66 || (_polygon66 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "101.76 146.23 103.01 145.51 104.42 146.33 103.18 147.05 101.76 146.23"
  })), _polygon67 || (_polygon67 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "103.53 147.25 104.77 146.53 106.19 147.34 104.95 148.06 103.53 147.25"
  })), _polygon68 || (_polygon68 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "105.29 148.27 106.54 147.54 107.96 148.36 106.71 149.08 105.29 148.27"
  })), _polygon69 || (_polygon69 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "108.31 148.56 109.72 149.38 108.48 150.1 107.06 149.28 108.31 148.56"
  })), _polygon70 || (_polygon70 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "85.5 137.3 86.92 138.11 85.68 138.83 84.26 138.02 85.5 137.3"
  })), _polygon71 || (_polygon71 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "88.68 139.13 87.44 139.85 86.02 139.03 87.27 138.31 88.68 139.13"
  })), _polygon72 || (_polygon72 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "90.45 140.15 89.21 140.87 87.79 140.05 89.03 139.33 90.45 140.15"
  })), _polygon73 || (_polygon73 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "92.22 141.16 90.98 141.88 89.56 141.07 90.8 140.34 92.22 141.16"
  })), _polygon74 || (_polygon74 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "93.98 142.18 92.74 142.9 91.32 142.08 92.57 141.36 93.98 142.18"
  })), _polygon75 || (_polygon75 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "95.75 143.19 94.51 143.91 93.09 143.1 94.33 142.38 95.75 143.19"
  })), _polygon76 || (_polygon76 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "96.1 143.4 97.86 144.41 97.87 144.41 98.21 144.61 99.63 145.43 99.63 145.43 100.35 145.84 101.4 146.44 101.4 146.44 102.51 147.09 104.58 148.28 103.34 149 101.18 147.75 100.15 147.17 100.15 147.17 99.08 146.55 98.38 146.15 98.39 146.15 96.99 145.35 96.62 145.13 96.62 145.13 94.85 144.12 96.1 143.4"
  })), _polygon77 || (_polygon77 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "106.34 149.29 105.1 150.01 103.68 149.2 104.93 148.48 106.34 149.29"
  })), _polygon78 || (_polygon78 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "108.11 150.31 106.87 151.03 105.45 150.22 106.69 149.49 108.11 150.31"
  })), _polygon79 || (_polygon79 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "117.04 147.58 118.28 146.86 119.7 147.67 118.46 148.39 117.04 147.58"
  })), _polygon80 || (_polygon80 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "118.81 148.6 120.05 147.87 121.47 148.69 120.22 149.41 118.81 148.6"
  })), _polygon81 || (_polygon81 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "120.57 149.61 121.82 148.89 123.23 149.71 121.99 150.43 120.57 149.61"
  })), _polygon82 || (_polygon82 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "118.09 148.61 116.85 149.33 115.43 148.51 116.67 147.79 118.09 148.61"
  })), _polygon83 || (_polygon83 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "119.85 149.62 118.61 150.34 117.19 149.53 118.44 148.81 119.85 149.62"
  })), _polygon84 || (_polygon84 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "121.62 150.64 120.38 151.36 118.96 150.55 120.2 149.82 121.62 150.64"
  })), _polygon85 || (_polygon85 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "116.48 149.54 115.23 150.26 113.82 149.45 115.06 148.72 116.48 149.54"
  })), _polygon86 || (_polygon86 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "118.24 150.56 117 151.28 115.58 150.46 116.83 149.74 118.24 150.56"
  })), _polygon87 || (_polygon87 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "120.01 151.57 118.77 152.29 117.35 151.48 118.59 150.76 120.01 151.57"
  })), _polygon88 || (_polygon88 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "112.2 150.38 113.45 149.66 114.87 150.47 113.62 151.19 112.2 150.38"
  })), _polygon89 || (_polygon89 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "113.97 151.4 115.21 150.67 116.63 151.49 115.39 152.21 113.97 151.4"
  })), _polygon90 || (_polygon90 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "115.73 152.41 116.98 151.69 118.4 152.51 117.15 153.23 115.73 152.41"
  })), _polygon91 || (_polygon91 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "110.59 151.31 111.84 150.59 113.25 151.41 112.01 152.13 110.59 151.31"
  })), _polygon92 || (_polygon92 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "112.36 152.33 113.6 151.61 115.02 152.42 113.78 153.14 112.36 152.33"
  })), _polygon93 || (_polygon93 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "114.12 153.35 115.37 152.62 116.79 153.44 115.54 154.16 114.12 153.35"
  })), _polygon94 || (_polygon94 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "111.64 152.34 110.4 153.06 108.98 152.25 110.23 151.53 111.64 152.34"
  })), _polygon95 || (_polygon95 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "113.41 153.36 112.17 154.08 110.75 153.26 111.99 152.54 113.41 153.36"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M104.55,127.95l9.79-5.68c.41-.25.93-.25,1.34,0l23.22,13.41c.28.17.36.54.19.81-.05.08-.11.14-.19.19l-9.57,5.55c-.49.29-1.1.29-1.59,0l-23.19-13.38c-.25-.15-.32-.48-.17-.73.04-.07.1-.13.17-.17Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M104.55,128.86l23.19,13.38c.49.29,1.1.29,1.59,0l9.57-5.55c.18-.11.29-.3.29-.51v1.23h0c0,.21-.11.4-.29.5l-9.57,5.5c-.49.28-1.1.28-1.59,0l-23.19-13.39c-.16-.1-.26-.27-.26-.46h0v-1.15c0,.19.1.36.26.45Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M104.55,128.86l23.19,13.38c.22.13.47.2.72.21v1.19c-.25,0-.5-.07-.72-.2l-23.19-13.39c-.16-.1-.26-.27-.26-.46h0v-1.18c0,.19.1.36.26.45Z"
  })), _polygon96 || (_polygon96 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-41",
    points: "129.94 128.84 111.9 118.39 111.9 127.33 129.94 137.77 129.94 128.84"
  })), _polygon97 || (_polygon97 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "114.41 116.95 111.9 118.39 129.94 128.84 132.46 127.39 114.41 116.95"
  })), _polygon98 || (_polygon98 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "132.46 127.39 129.94 128.84 129.94 137.77 132.46 136.31 132.46 127.39"
  })), _polygon99 || (_polygon99 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "93.65 72.89 148.51 104.71 148.51 145.07 93.65 113.13 93.65 72.89"
  })), _polygon100 || (_polygon100 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-36",
    points: "148.51 104.71 150.33 103.6 150.33 143.97 148.51 145.07 148.51 104.71"
  })), _polygon101 || (_polygon101 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "93.65 72.89 95.52 71.81 150.33 103.6 148.51 104.71 93.65 72.89"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M93.65,72.9v40.24l54.86,31.94v-40.37l-54.86-31.81ZM147.24,142.82l-52.29-30.41v-37.26l52.29,30.31v37.36Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M73.34,122.73c-.57,5.77-4.82,10.07-9.5,9.61s-8-5.51-7.43-11.28,4.82-10.06,9.49-9.6,8.01,5.51,7.44,11.27Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M80.33,136.17s2,.49,2.74.56,3.38.63,4.47.3-1-1.06-1.47-1.43-.48-1.32.62-1.65,3.6-.18,4.92-.37-1.31-4.18-3.46-4.55c-2-.4-4.07-.12-5.89.8-1.83.9-2.83,2.43-3.68,2.72l1.75,3.62Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M80.57,130.73l-13.91,3.49-.7,8.83,16.42-5.64c.34-3.11-1.81-6.68-1.81-6.68Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M46.24,134.47s-3.85,4.84,0,11.52c0,0,2.69,3.72,10.07.07l-10.07-11.59Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M57.67,128.81s6-.41,10.69,2.87c.26.65.71,1.22,1.29,1.62.94.63,5.61,2.5,5.61,2.5,0,0-2.06,27.37.3,40.7,0,0-10.13,7.91-26,0,0,0-2.31-33.61-3.33-42,.01-.03,2.68-3.29,11.44-5.69Z"
  })), _polygon102 || (_polygon102 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "55.03 173.99 26.65 157.58 36.2 185.25 64.59 201.62 55.03 173.99"
  })), _polygon103 || (_polygon103 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "29.78 155.76 26.65 157.58 55.03 173.99 58.2 172.15 29.78 155.76"
  })), _polygon104 || (_polygon104 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "58.2 172.15 55.03 173.99 64.59 201.62 67.79 199.78 58.2 172.15"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-25",
    d: "M99.03,148.3s1.55-1.56,2.14-2,2.67-2.41,3.84-2.67-.82,1.77-1.07,2.4,1.2-.51,2.29-.92c1.22-.4,2.53-.35,3.72.13,2.69,1,2.56,6.33.36,5.7-3.61-1-5.23,1.82-7.39,2.42-1,.26-2.02.45-3.05.56l-.84-5.62Z"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M75.24,135.8l11.73,15.55,12.2-3.6s2.62,3.3,1.77,6.79l-16.28,6.34-13.23-14.55s-4.41-9.24,3.81-10.53Z"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M68.04,102.41c-.52.69-1.4,1.75-2.7,2.81-3.42,2.78-5.23,1.85-9.25,4.4-1.46.93-5.1,3.39-5.78,7.31-.23,1.35.08,1.39,2.32,10.57.45,1.84.82,3.34.28,5.12-.63,2.02-2.06,3.14-1.65,3.74.44.64,2.11-.58,3.91.17,1.85.77,1.85,2.81,2.81,2.81,1.24,0,2.54-3.87,2.31-7.38-.03-.45-.07-.63-.61-3.63-.4-2.2-.73-3.97-.93-5.07.12-1.53,1.1-2.78,2.41-3.13,1.29-.35,2.39.32,2.59.46.88.25,2.52-2.09,2.81-3.71.15-.81.41-1.42.75-1.89.65-.92,1.34-1.16,1.95-1.63,1.76-1.36,1.99-4.46,1.54-6.52-.54-2.5-2.19-3.97-2.76-4.43Z"
  })), _polygon105 || (_polygon105 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "229.8 189.34 210.99 178.43 210.99 185.47 229.8 196.35 229.8 189.34"
  })), _polygon106 || (_polygon106 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "230.43 167.26 210.99 178.43 229.8 189.34 249.26 178.16 230.43 167.26"
  })), _polygon107 || (_polygon107 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "249.26 178.16 229.8 189.34 229.8 196.35 249.26 185.09 249.26 178.16"
  })), _polygon108 || (_polygon108 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "229.8 177.84 210.99 166.92 210.99 173.96 229.8 184.84 229.8 177.84"
  })), _polygon109 || (_polygon109 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "230.43 155.75 210.99 166.92 229.8 177.84 249.26 166.65 230.43 155.75"
  })), _polygon110 || (_polygon110 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "249.26 166.65 229.8 177.84 229.8 184.84 249.26 173.58 249.26 166.65"
  })), _polygon111 || (_polygon111 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "197.99 207.76 179.19 196.84 179.19 203.88 198 214.76 197.99 207.76"
  })), _polygon112 || (_polygon112 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "198.63 185.67 179.19 196.84 197.99 207.76 217.46 196.57 198.63 185.67"
  })), _polygon113 || (_polygon113 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "217.46 196.57 197.99 207.76 198 214.76 217.46 203.5 217.46 196.57"
  })), _polygon114 || (_polygon114 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "197.99 196.25 179.19 185.34 179.19 192.37 198 203.26 197.99 196.25"
  })), _polygon115 || (_polygon115 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "198.63 174.17 179.19 185.34 197.99 196.25 217.46 185.07 198.63 174.17"
  })), _polygon116 || (_polygon116 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "217.46 185.07 197.99 196.25 198 203.26 217.46 192 217.46 185.07"
  })), _polygon117 || (_polygon117 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "166.19 226.17 147.39 215.26 147.39 222.29 166.19 233.18 166.19 226.17"
  })), _polygon118 || (_polygon118 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "166.83 204.09 147.39 215.26 166.19 226.17 185.66 214.99 166.83 204.09"
  })), _polygon119 || (_polygon119 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "185.66 214.99 166.19 226.17 166.19 233.18 185.66 221.92 185.66 214.99"
  })), _polygon120 || (_polygon120 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-40",
    points: "166.19 214.66 147.39 203.75 147.39 210.79 166.19 221.67 166.19 214.66"
  })), _polygon121 || (_polygon121 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "166.83 192.58 147.39 203.75 166.19 214.66 185.66 203.48 166.83 192.58"
  })), _polygon122 || (_polygon122 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-28",
    points: "185.66 203.48 166.19 214.66 166.19 221.67 185.66 210.41 185.66 203.48"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M172.06,207.78l-1.18-.69c-.89.35-1.82.57-2.77.67v1h-2.87v-1c-.95-.1-1.88-.33-2.77-.67l-1.17.69-2-1.18,1.18-.68c-.52-.42-.92-.97-1.16-1.6h-1.66v-1.67h1.58c.23-.63.62-1.18,1.14-1.6l-1.14-.64,2-1.18,1.18.68c.89-.34,1.82-.56,2.76-.66v-1h2.87v1c.95.1,1.88.32,2.78.66l1.17-.68,2,1.18-1.18.68c.52.42.93.97,1.16,1.6h1.66v1.66h-1.6c-.23.63-.62,1.18-1.14,1.6l1.18.68-2.02,1.15ZM164,205.03c1.68.85,3.65.85,5.33,0,1.46-.86,1.45-2.24,0-3.09-1.67-.85-3.65-.85-5.32,0-1.47.85-1.46,2.23,0,3.09"
  })), _polygon123 || (_polygon123 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-11",
    points: "200.06 180.24 201.89 184.14 203.72 188.05 196.97 187 190.22 185.96 195.14 183.1 200.06 180.24"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M223.07,165.82c-1-.59-.56-1.44,1.38-2.57.79-.47,1.66-.81,2.56-1,.62-.17,1.27-.11,1.85.16.2.11.37.26.49.45.1.16.17.33.23.51l1.78-.44c-.1-.29-.26-.55-.47-.77-.22-.23-.48-.43-.76-.58-1.01-.55-2.17-.77-3.31-.61-1.42.18-2.78.65-4,1.39-1.03.47-1.87,1.27-2.39,2.28-.24.73.11,1.36,1,1.91.61.36,1.29.59,2,.67l1.38-.8c-.61-.1-1.2-.3-1.74-.6Z"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M231.52,167.97c.17-.42.17-.89,0-1.31-.13-.29-.18-.6-.14-.91.07-.25.25-.46.49-.57.27-.16.57-.26.88-.28.29-.01.58.05.83.19.2.12.38.27.53.45.11.16.2.33.29.5l1.76-.42c-.28-.6-.74-1.08-1.32-1.39-.68-.39-1.46-.59-2.24-.56-.81,0-1.6.23-2.3.64-.31.17-.6.39-.84.66-.16.2-.27.44-.33.69-.03.3,0,.61.11.89.13.32.17.66.12,1-.06.27-.24.49-.49.6-.27.16-.58.25-.89.25-.33,0-.65-.07-.93-.24-.52-.31-.92-.79-1.12-1.36l-1.53.89c.34.57.84,1.04,1.44,1.33.71.42,1.52.64,2.34.63.84-.02,1.66-.26,2.38-.7.41-.22.75-.56.96-.98Z"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M239.67,167.04c-.68-.39-1.46-.59-2.24-.57-.81.02-1.6.24-2.3.65-.31.17-.59.39-.83.66-.17.2-.28.43-.33.69-.04.3,0,.6.11.88.12.32.17.66.12,1-.08.26-.25.47-.49.6-.27.16-.58.24-.9.25-.32,0-.64-.07-.92-.24-.52-.31-.92-.79-1.12-1.36l-1.53.89c.33.58.83,1.04,1.43,1.33.71.42,1.52.64,2.34.63.84-.02,1.67-.26,2.39-.7.42-.21.77-.53,1-.94.17-.42.17-.9,0-1.32-.12-.28-.17-.59-.14-.9.08-.26.26-.47.5-.58.27-.16.57-.25.88-.27.29-.02.58.05.83.19.2.11.38.27.52.45.11.16.21.32.29.5l1.76-.43c-.29-.61-.77-1.11-1.37-1.41Z"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M229.38,104.23l-18.27-10.53c-.57-.33-1.28-.31-1.82.07h0l-4,2.31,1.87,2.53.69.8v18.09c0,1.08.57,2.07,1.51,2.61l13.67,7.91.14.76,2.79,3.91,4.29-2.53h0c.41-.25.65-.69.65-1.17v-22c.03-1.13-.55-2.18-1.52-2.76Z"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M225.11,106.74l-18.48-10.66c-.65-.36-1.47-.12-1.83.53-.11.2-.16.41-.17.64v22.16c0,1.08.57,2.08,1.51,2.62l18.47,10.68c.67.38,1.53.14,1.91-.53.12-.21.18-.44.18-.67v-22.1c-.02-1.11-.63-2.12-1.59-2.67Z"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M226.67,131.47v-22.06c0-.36-.08-.72-.22-1.06l4.29-2.47c.12.32.19.66.2,1v22c0,.48-.24.92-.65,1.17h0l-4.25,2.5c.37-.24.61-.64.63-1.08Z"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-33",
    d: "M250.24,60.24l-18.27-10.54c-.57-.33-1.28-.3-1.83.07h0l-4,2.32,1.87,2.52.69.8v18.09c0,1.08.57,2.08,1.51,2.62l13.67,7.9.14.76,2.79,3.91,4.29-2.52h0c.41-.25.66-.69.65-1.17v-22c.04-1.13-.54-2.18-1.51-2.76Z"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M246.01,62.75l-18.48-10.67c-.66-.35-1.49-.1-1.84.56-.1.19-.16.4-.16.62v22.15c0,1.08.57,2.07,1.51,2.61l18.47,10.68c.67.38,1.52.15,1.9-.52.12-.21.18-.44.18-.68v-22.09c-.01-1.1-.62-2.12-1.58-2.66Z"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-34",
    d: "M247.56,87.47v-22.06c0-.36-.08-.72-.21-1.06l4.29-2.47c.12.32.18.66.19,1v22c0,.48-.24.92-.65,1.17h0l-4.26,2.5c.38-.24.61-.64.64-1.08Z"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M189.24,60.56l-18.3-10.54c-.57-.33-1.28-.3-1.83.07h0l-4,2.31,1.87,2.53.69.8v18.09c0,1.08.57,2.08,1.51,2.62l13.67,7.9.14.76,2.79,3.91,4.29-2.52h0c.41-.25.65-.69.65-1.17v-22c.04-1.12-.52-2.18-1.48-2.76Z"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M184.94,63.07l-18.48-10.66c-.65-.36-1.47-.12-1.83.53-.11.2-.17.42-.17.65v22.11c0,1.08.57,2.08,1.51,2.62l18.47,10.68c.67.38,1.52.15,1.9-.52.12-.21.18-.44.18-.68v-22c.01-1.13-.6-2.18-1.58-2.73Z"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M186.49,87.79v-22c0-.36-.08-.72-.21-1.06l4.29-2.47c.12.32.18.66.19,1v22c0,.48-.24.92-.65,1.17h0l-4.26,2.5c.39-.25.63-.68.64-1.14Z"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M149.24,17.9l-18.29-10.49c-.57-.33-1.28-.3-1.83.07h0l-4,2.32,1.86,2.52.7.8v18.09c0,1.08.56,2.08,1.5,2.62l13.67,7.9.14.76,2.79,3.91,4.29-2.52h0c.41-.24.67-.69.66-1.17v-22c.06-1.14-.52-2.22-1.49-2.81Z"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M144.94,20.41l-18.48-10.67c-.66-.35-1.49-.1-1.84.56-.1.19-.16.4-.16.62v22.12c0,1.08.57,2.07,1.51,2.61l18.48,10.68c.67.38,1.52.15,1.9-.52.12-.21.18-.44.18-.68v-22c0-1.13-.6-2.17-1.59-2.72Z"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M146.5,45.13v-22c0-.36-.08-.72-.21-1.06l4.28-2.47c.12.32.19.66.2,1v22c0,.48-.25.93-.66,1.17h0l-4.25,2.5c.39-.25.63-.68.64-1.14Z"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M181.29,67.41c-.96-1.75-2.36-3.23-4.06-4.29-1.19-.86-2.74-1.01-4.08-.41-2,1.14-2.23,4.57-.68,8l-5,2.86,1.46,2.53,5-2.86c.87,1.24,1.98,2.28,3.27,3.06,1.18.85,2.73,1.01,4.06.41,2.26-1.24,2.27-5.42.03-9.3ZM179.8,74.22c-.85.38-1.84.28-2.6-.26-1.09-.67-1.98-1.62-2.6-2.74-1.43-2.48-1.43-5.16,0-6,.85-.38,1.84-.28,2.6.26,1.08.68,1.98,1.63,2.6,2.75,1.44,2.49,1.44,5.18,0,5.99Z"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M130.24,22.31c.31.18.59.4.84.65.28.28.56.57.84.89l.52-1.19c-.62-.74-1.36-1.37-2.19-1.87-.55-.37-1.21-.55-1.87-.54-.53.05-.99.37-1.23.84-.31.66-.46,1.38-.43,2.11-.03,1.31.27,2.6.86,3.77.57,1.08,1.43,1.98,2.5,2.58.62.39,1.33.65,2.06.75v-1.53c-.67-.1-1.32-.32-1.91-.65-1.25-.72-1.88-2-1.87-4-.08-.66.1-1.33.49-1.87.39-.3.81-.29,1.39.06Z"
  })), _polygon124 || (_polygon124 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "136.37 25.86 135.25 25.21 135.24 27.51 133.26 26.36 133.26 27.65 135.24 28.8 135.23 31.07 136.35 31.71 136.36 29.45 138.34 30.59 138.35 29.3 136.36 28.15 136.37 25.86"
  })), _polygon125 || (_polygon125 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "142.35 31.61 142.36 29.32 141.24 28.67 141.23 30.96 139.25 29.82 139.25 31.11 141.23 32.26 141.22 34.52 142.34 35.17 142.35 32.9 144.33 34.05 144.33 32.76 142.35 31.61"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M231.55,61.35c-.24.35-.35.78-.3,1.2v2.72c0,.5-.16.77-.48.8-.49-.02-.97-.18-1.38-.46v1.8c.52.29.99.67,1.37,1.13.32.41.49.92.48,1.44v2.61c-.01.53.08,1.07.29,1.56.24.49.58.92,1,1.27.55.48,1.15.91,1.79,1.26v-1.74c-.39-.22-.74-.52-1-.89-.17-.31-.26-.65-.26-1v-2.64c-.07-1.13-.68-2.15-1.65-2.74v-.1c1.09.45,1.64.14,1.66-.92v-2.5c0-.4.09-.65.27-.73s.51,0,1,.26v-1.74c-.55-.35-1.15-.62-1.78-.8-.35-.12-.74-.04-1.01.21Z"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M241.88,72.5c-.31-.39-.47-.87-.47-1.36v-2.73c.02-.79-.22-1.56-.68-2.2-.65-.78-1.45-1.42-2.35-1.88v1.74c.4.21.74.52,1,.88.17.3.26.65.26,1v2.5c.07,1.16.69,2.22,1.67,2.85v.1c-.38-.21-.83-.25-1.24-.13-.29.14-.44.46-.44,1v2.58c0,.4-.09.65-.26.74s-.52,0-1-.27v1.74c.69.51,1.51.8,2.37.84.45-.09.68-.56.68-1.42v-2.61c0-.54.16-.84.47-.89.5.01.98.17,1.38.46v-1.84c-.53-.28-1-.65-1.39-1.1Z"
  })), _polygon126 || (_polygon126 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "206.95 110.33 212.67 116.55 212.68 114.96 208.73 110.81 212.69 110.99 212.69 109.4 206.95 109.38 206.95 110.33"
  })), _polygon127 || (_polygon127 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "213.26 118.24 214.86 119.16 218.04 111.27 216.43 110.35 213.26 118.24"
  })), _polygon128 || (_polygon128 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "218.59 112.81 218.59 114.4 222.54 118.78 218.58 118.37 218.57 119.96 224.32 120.36 224.32 119.41 218.59 112.81"
  })), _polygon129 || (_polygon129 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "100.48 81.28 100.48 82.35 104.98 84.94 104.98 83.87 100.48 81.28"
  })), _polygon130 || (_polygon130 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.48 83.23 100.48 84.3 104.98 86.9 104.98 85.83 100.48 83.23"
  })), _polygon131 || (_polygon131 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.48 85.19 100.48 86.26 104.98 88.85 104.98 87.78 100.48 85.19"
  })), _polygon132 || (_polygon132 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "134.42 107.79 134.42 106.72 106.66 90.71 106.66 91.78 134.42 107.79"
  })), _polygon133 || (_polygon133 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.48 87.14 100.48 88.21 104.98 90.81 104.98 89.74 100.48 87.14"
  })), _polygon134 || (_polygon134 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.48 89.1 100.48 90.17 104.98 92.76 104.98 91.69 100.48 89.1"
  })), _polygon135 || (_polygon135 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "134.42 109.74 134.42 108.67 106.66 92.67 106.66 93.73 134.42 109.74"
  })), _polygon136 || (_polygon136 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.48 94.96 100.48 96.03 104.98 98.63 104.98 97.56 100.48 94.96"
  })), _polygon137 || (_polygon137 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-24",
    points: "100.48 96.92 100.48 97.99 104.98 100.58 104.98 99.51 100.48 96.92"
  })), _polygon138 || (_polygon138 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.48 104.74 100.48 105.81 104.98 108.41 104.98 107.33 100.48 104.74"
  })), _polygon139 || (_polygon139 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "100.48 106.7 100.48 107.77 104.98 110.36 104.98 109.29 100.48 106.7"
  })), _polygon140 || (_polygon140 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "124.17 120.36 106.66 110.26 106.66 111.33 124.17 121.43 124.17 120.36"
  })), _polygon141 || (_polygon141 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "125.09 120.89 125.09 121.97 134.42 127.34 134.42 126.27 125.09 120.89"
  })), _polygon142 || (_polygon142 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "115.46 113.38 106.66 108.31 106.66 109.38 115.46 114.45 115.46 113.38"
  })), _polygon143 || (_polygon143 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "116.38 113.92 116.38 114.98 134.42 125.39 134.42 124.32 116.38 113.92"
  })), _polygon144 || (_polygon144 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.04 117.08 132.04 118.15 134.42 119.52 134.42 118.45 132.04 117.08"
  })), _polygon145 || (_polygon145 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "119.13 107.68 106.66 100.49 106.66 101.56 119.13 108.75 119.13 107.68"
  })), _polygon146 || (_polygon146 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "114.02 89.09 106.66 84.84 106.66 85.91 114.02 90.16 114.02 89.09"
  })), _polygon147 || (_polygon147 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "126.09 96.05 114.95 89.62 114.95 90.69 126.09 97.12 126.09 96.05"
  })), _polygon148 || (_polygon148 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "119.59 94.26 111.75 89.73 111.75 90.8 119.59 95.33 119.59 94.26"
  })), _polygon149 || (_polygon149 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "127.83 99 120.52 94.79 120.52 95.86 127.83 100.08 127.83 99"
  })), _polygon150 || (_polygon150 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "128.75 99.54 128.75 100.61 134.42 103.88 134.42 102.81 128.75 99.54"
  })), _polygon151 || (_polygon151 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "108.11 89.59 108.11 90.66 114.02 94.07 114.02 93 108.11 89.59"
  })), _polygon152 || (_polygon152 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.1 103.43 114.95 93.53 114.95 94.6 132.1 104.5 132.1 103.43"
  })), _polygon153 || (_polygon153 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "122.28 103.63 111.07 97.16 111.07 98.23 122.28 104.7 122.28 103.63"
  })), _polygon154 || (_polygon154 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.1 109.29 123.2 104.16 123.2 105.23 132.1 110.36 132.1 109.29"
  })), _polygon155 || (_polygon155 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "131.12 114.59 120.06 108.21 120.06 109.28 131.12 115.66 131.12 114.59"
  })), _polygon156 || (_polygon156 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "125.09 113.07 125.09 114.14 131.12 117.62 131.12 116.55 125.09 113.07"
  })), _polygon157 || (_polygon157 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "108.83 103.69 106.66 102.44 106.66 103.51 108.83 104.76 108.83 103.69"
  })), _polygon158 || (_polygon158 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "112.9 106.04 112.9 107.11 124.17 113.61 124.17 112.54 112.9 106.04"
  })), _polygon159 || (_polygon159 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "111.98 105.51 109.76 104.23 109.76 105.3 111.98 106.58 111.98 105.51"
  })), _polygon160 || (_polygon160 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "122.09 113.29 109.76 106.18 109.76 107.25 122.09 114.36 122.09 113.29"
  })), _polygon161 || (_polygon161 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 101.99 136.37 102.28 137.61 103 137.61 102.7 136.37 101.99"
  })), _polygon162 || (_polygon162 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 102.53 136.37 102.82 137.61 103.54 137.61 103.24 136.37 102.53"
  })), _polygon163 || (_polygon163 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 103.07 136.37 103.36 137.61 104.08 137.61 103.78 136.37 103.07"
  })), _polygon164 || (_polygon164 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.72 109.29 145.72 109 138.07 104.59 138.07 104.88 145.72 109.29"
  })), _polygon165 || (_polygon165 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 103.61 136.37 103.9 137.61 104.61 137.61 104.32 136.37 103.61"
  })), _polygon166 || (_polygon166 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 104.14 136.37 104.44 137.61 105.15 137.61 104.86 136.37 104.14"
  })), _polygon167 || (_polygon167 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.72 109.83 145.72 109.54 138.07 105.13 138.07 105.42 145.72 109.83"
  })), _polygon168 || (_polygon168 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 105.76 136.37 106.06 137.61 106.77 137.61 106.48 136.37 105.76"
  })), _polygon169 || (_polygon169 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 106.3 136.37 106.59 137.61 107.31 137.61 107.01 136.37 106.3"
  })), _polygon170 || (_polygon170 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 108.45 136.37 108.75 137.61 109.47 137.61 109.17 136.37 108.45"
  })), _polygon171 || (_polygon171 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 108.99 136.37 109.29 137.61 110 137.61 109.71 136.37 108.99"
  })), _polygon172 || (_polygon172 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.9 112.76 138.07 109.98 138.07 110.27 142.9 113.05 142.9 112.76"
  })), _polygon173 || (_polygon173 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.15 112.91 143.15 113.2 145.72 114.68 145.72 114.39 143.15 112.91"
  })), _polygon174 || (_polygon174 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.5 110.84 138.07 109.44 138.07 109.73 140.5 111.13 140.5 110.84"
  })), _polygon175 || (_polygon175 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.75 110.98 140.75 111.28 145.72 114.14 145.72 113.85 140.75 110.98"
  })), _polygon176 || (_polygon176 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.07 111.86 145.07 112.15 145.72 112.53 145.72 112.23 145.07 111.86"
  })), _polygon177 || (_polygon177 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.51 109.26 138.07 107.28 138.07 107.58 141.51 109.56 141.51 109.26"
  })), _polygon178 || (_polygon178 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.1 104.14 138.07 102.97 138.07 103.27 140.1 104.44 140.1 104.14"
  })), _polygon179 || (_polygon179 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.43 106.06 140.35 104.29 140.35 104.58 143.43 106.35 143.43 106.06"
  })), _polygon180 || (_polygon180 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.63 105.57 139.47 104.32 139.47 104.61 141.63 105.86 141.63 105.57"
  })), _polygon181 || (_polygon181 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.9 106.87 141.89 105.71 141.89 106.01 143.9 107.17 143.9 106.87"
  })), _polygon182 || (_polygon182 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.16 107.02 144.16 107.32 145.72 108.22 145.72 107.92 144.16 107.02"
  })), _polygon183 || (_polygon183 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.47 104.28 138.47 104.58 140.1 105.51 140.1 105.22 138.47 104.28"
  })), _polygon184 || (_polygon184 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.08 108.09 140.35 105.37 140.35 105.66 145.08 108.39 145.08 108.09"
  })), _polygon185 || (_polygon185 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.37 108.15 139.29 106.37 139.29 106.66 142.37 108.44 142.37 108.15"
  })), _polygon186 || (_polygon186 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.08 109.71 142.63 108.3 142.63 108.59 145.08 110 145.08 109.71"
  })), _polygon187 || (_polygon187 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.81 111.17 141.76 109.41 141.76 109.71 144.81 111.47 144.81 111.17"
  })), _polygon188 || (_polygon188 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.15 110.75 143.15 111.05 144.81 112 144.81 111.71 143.15 110.75"
  })), _polygon189 || (_polygon189 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.67 108.17 138.07 107.82 138.07 108.12 138.67 108.46 138.67 108.17"
  })), _polygon190 || (_polygon190 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "139.79 108.81 139.79 109.11 142.9 110.9 142.9 110.6 139.79 108.81"
  })), _polygon191 || (_polygon191 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "139.54 108.67 138.92 108.31 138.92 108.61 139.54 108.96 139.54 108.67"
  })), _polygon192 || (_polygon192 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.32 110.81 138.92 108.85 138.92 109.15 142.32 111.11 142.32 110.81"
  })), _polygon193 || (_polygon193 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 111.11 136.37 111.4 137.61 112.12 137.61 111.82 136.37 111.11"
  })), _polygon194 || (_polygon194 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 111.64 136.37 111.94 137.61 112.66 137.61 112.36 136.37 111.64"
  })), _polygon195 || (_polygon195 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 112.18 136.37 112.48 137.61 113.19 137.61 112.9 136.37 112.18"
  })), _polygon196 || (_polygon196 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.72 118.41 145.72 118.12 138.07 113.71 138.07 114 145.72 118.41"
  })), _polygon197 || (_polygon197 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 112.72 136.37 113.02 137.61 113.73 137.61 113.44 136.37 112.72"
  })), _polygon198 || (_polygon198 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 113.26 136.37 113.56 137.61 114.27 137.61 113.98 136.37 113.26"
  })), _polygon199 || (_polygon199 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.72 118.95 145.72 118.66 138.07 114.24 138.07 114.54 145.72 118.95"
  })), _polygon200 || (_polygon200 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 114.88 136.37 115.17 137.61 115.89 137.61 115.59 136.37 114.88"
  })), _polygon201 || (_polygon201 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 115.42 136.37 115.71 137.61 116.43 137.61 116.13 136.37 115.42"
  })), _polygon202 || (_polygon202 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 117.57 136.37 117.87 137.61 118.58 137.61 118.29 136.37 117.57"
  })), _polygon203 || (_polygon203 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 118.11 136.37 118.41 137.61 119.12 137.61 118.83 136.37 118.11"
  })), _polygon204 || (_polygon204 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.9 121.88 138.07 119.09 138.07 119.39 142.9 122.17 142.9 121.88"
  })), _polygon205 || (_polygon205 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.15 122.02 143.15 122.32 145.72 123.8 145.72 123.5 143.15 122.02"
  })), _polygon206 || (_polygon206 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.5 119.95 138.07 118.56 138.07 118.85 140.5 120.25 140.5 119.95"
  })), _polygon207 || (_polygon207 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.75 120.1 140.75 120.39 145.72 123.26 145.72 122.97 140.75 120.1"
  })), _polygon208 || (_polygon208 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.07 120.97 145.07 121.27 145.72 121.64 145.72 121.35 145.07 120.97"
  })), _polygon209 || (_polygon209 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.51 118.38 138.07 116.4 138.07 116.69 141.51 118.68 141.51 118.38"
  })), _polygon210 || (_polygon210 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.1 113.26 138.07 112.09 138.07 112.38 140.1 113.55 140.1 113.26"
  })), _polygon211 || (_polygon211 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.43 115.18 140.35 113.41 140.35 113.7 143.43 115.47 143.43 115.18"
  })), _polygon212 || (_polygon212 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.63 114.68 139.47 113.44 139.47 113.73 141.63 114.98 141.63 114.68"
  })), _polygon213 || (_polygon213 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.9 115.99 141.89 114.83 141.89 115.13 143.9 116.29 143.9 115.99"
  })), _polygon214 || (_polygon214 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.16 116.14 144.16 116.43 145.72 117.33 145.72 117.04 144.16 116.14"
  })), _polygon215 || (_polygon215 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.47 113.4 138.47 113.69 140.1 114.63 140.1 114.34 138.47 113.4"
  })), _polygon216 || (_polygon216 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.08 117.21 140.35 114.48 140.35 114.78 145.08 117.5 145.08 117.21"
  })), _polygon217 || (_polygon217 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.37 117.27 139.29 115.48 139.29 115.78 142.37 117.56 142.37 117.27"
  })), _polygon218 || (_polygon218 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.08 118.83 142.63 117.41 142.63 117.71 145.08 119.12 145.08 118.83"
  })), _polygon219 || (_polygon219 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.81 120.29 141.76 118.53 141.76 118.82 144.81 120.58 144.81 120.29"
  })), _polygon220 || (_polygon220 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.15 119.87 143.15 120.16 144.81 121.12 144.81 120.83 143.15 119.87"
  })), _polygon221 || (_polygon221 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.67 117.28 138.07 116.94 138.07 117.23 138.67 117.58 138.67 117.28"
  })), _polygon222 || (_polygon222 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "139.79 117.93 139.79 118.22 142.9 120.02 142.9 119.72 139.79 117.93"
  })), _polygon223 || (_polygon223 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "139.54 117.78 138.92 117.43 138.92 117.72 139.54 118.08 139.54 117.78"
  })), _polygon224 || (_polygon224 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.32 119.93 138.92 117.97 138.92 118.26 142.32 120.22 142.32 119.93"
  })), _polygon225 || (_polygon225 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 120.22 136.37 120.52 137.61 121.23 137.61 120.94 136.37 120.22"
  })), _polygon226 || (_polygon226 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 120.76 136.37 121.06 137.61 121.77 137.61 121.48 136.37 120.76"
  })), _polygon227 || (_polygon227 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 121.3 136.37 121.6 137.61 122.31 137.61 122.02 136.37 121.3"
  })), _polygon228 || (_polygon228 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.72 127.53 145.72 127.23 138.07 122.82 138.07 123.12 145.72 127.53"
  })), _polygon229 || (_polygon229 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 121.84 136.37 122.14 137.61 122.85 137.61 122.56 136.37 121.84"
  })), _polygon230 || (_polygon230 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 122.38 136.37 122.67 137.61 123.39 137.61 123.09 136.37 122.38"
  })), _polygon231 || (_polygon231 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.72 128.07 145.72 127.77 138.07 123.36 138.07 123.66 145.72 128.07"
  })), _polygon232 || (_polygon232 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 124 136.37 124.29 137.61 125 137.61 124.71 136.37 124"
  })), _polygon233 || (_polygon233 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 124.53 136.37 124.83 137.61 125.54 137.61 125.25 136.37 124.53"
  })), _polygon234 || (_polygon234 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 126.69 136.37 126.98 137.61 127.7 137.61 127.4 136.37 126.69"
  })), _polygon235 || (_polygon235 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 127.23 136.37 127.52 137.61 128.24 137.61 127.94 136.37 127.23"
  })), _polygon236 || (_polygon236 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.9 130.99 138.07 128.21 138.07 128.51 142.9 131.29 142.9 130.99"
  })), _polygon237 || (_polygon237 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.15 131.14 143.15 131.44 145.72 132.92 145.72 132.62 143.15 131.14"
  })), _polygon238 || (_polygon238 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.5 129.07 138.07 127.67 138.07 127.97 140.5 129.37 140.5 129.07"
  })), _polygon239 || (_polygon239 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.75 129.22 140.75 129.51 145.72 132.38 145.72 132.08 140.75 129.22"
  })), _polygon240 || (_polygon240 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.07 130.09 145.07 130.38 145.72 130.76 145.72 130.47 145.07 130.09"
  })), _polygon241 || (_polygon241 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.51 127.5 138.07 125.52 138.07 125.81 141.51 127.79 141.51 127.5"
  })), _polygon242 || (_polygon242 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.1 122.38 138.07 121.21 138.07 121.5 140.1 122.67 140.1 122.38"
  })), _polygon243 || (_polygon243 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.43 124.29 140.35 122.52 140.35 122.82 143.43 124.59 143.43 124.29"
  })), _polygon244 || (_polygon244 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.63 123.8 139.47 122.55 139.47 122.85 141.63 124.09 141.63 123.8"
  })), _polygon245 || (_polygon245 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.9 125.11 141.89 123.95 141.89 124.24 143.9 125.4 143.9 125.11"
  })), _polygon246 || (_polygon246 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.16 125.25 144.16 125.55 145.72 126.45 145.72 126.16 144.16 125.25"
  })), _polygon247 || (_polygon247 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.47 122.51 138.47 122.81 140.1 123.75 140.1 123.45 138.47 122.51"
  })), _polygon248 || (_polygon248 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.08 126.33 140.35 123.6 140.35 123.89 145.08 126.62 145.08 126.33"
  })), _polygon249 || (_polygon249 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.37 126.38 139.29 124.6 139.29 124.89 142.37 126.68 142.37 126.38"
  })), _polygon250 || (_polygon250 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.08 127.94 142.63 126.53 142.63 126.82 145.08 128.24 145.08 127.94"
  })), _polygon251 || (_polygon251 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.81 129.4 141.76 127.64 141.76 127.94 144.81 129.7 144.81 129.4"
  })), _polygon252 || (_polygon252 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.15 128.99 143.15 129.28 144.81 130.24 144.81 129.94 143.15 128.99"
  })), _polygon253 || (_polygon253 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.67 126.4 138.07 126.06 138.07 126.35 138.67 126.69 138.67 126.4"
  })), _polygon254 || (_polygon254 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "139.79 127.05 139.79 127.34 142.9 129.13 142.9 128.84 139.79 127.05"
  })), _polygon255 || (_polygon255 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "139.54 126.9 138.92 126.55 138.92 126.84 139.54 127.19 139.54 126.9"
  })), _polygon256 || (_polygon256 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.32 129.05 138.92 127.09 138.92 127.38 142.32 129.34 142.32 129.05"
  })), _polygon257 || (_polygon257 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 129.34 136.37 129.64 137.61 130.35 137.61 130.06 136.37 129.34"
  })), _polygon258 || (_polygon258 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 129.88 136.37 130.17 137.61 130.89 137.61 130.59 136.37 129.88"
  })), _polygon259 || (_polygon259 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 130.42 136.37 130.71 137.61 131.43 137.61 131.13 136.37 130.42"
  })), _polygon260 || (_polygon260 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.72 136.65 145.72 136.35 138.07 131.94 138.07 132.24 145.72 136.65"
  })), _polygon261 || (_polygon261 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 130.96 136.37 131.25 137.61 131.97 137.61 131.67 136.37 130.96"
  })), _polygon262 || (_polygon262 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 131.5 136.37 131.79 137.61 132.5 137.61 132.21 136.37 131.5"
  })), _polygon263 || (_polygon263 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.72 137.18 145.72 136.89 138.07 132.48 138.07 132.77 145.72 137.18"
  })), _polygon264 || (_polygon264 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 133.11 136.37 133.41 137.61 134.12 137.61 133.83 136.37 133.11"
  })), _polygon265 || (_polygon265 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "136.37 133.65 136.37 133.95 137.61 134.66 137.61 134.37 136.37 133.65"
  })), _polygon266 || (_polygon266 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.07 139.21 145.07 139.5 145.72 139.88 145.72 139.58 145.07 139.21"
  })), _polygon267 || (_polygon267 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.51 136.62 138.07 134.63 138.07 134.93 141.51 136.91 141.51 136.62"
  })), _polygon268 || (_polygon268 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "140.1 131.49 138.07 130.32 138.07 130.62 140.1 131.79 140.1 131.49"
  })), _polygon269 || (_polygon269 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.43 133.41 140.35 131.64 140.35 131.94 143.43 133.71 143.43 133.41"
  })), _polygon270 || (_polygon270 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "141.63 132.92 139.47 131.67 139.47 131.97 141.63 133.21 141.63 132.92"
  })), _polygon271 || (_polygon271 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.9 134.23 141.89 133.06 141.89 133.36 143.9 134.52 143.9 134.23"
  })), _polygon272 || (_polygon272 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.16 134.37 144.16 134.67 145.72 135.57 145.72 135.27 144.16 134.37"
  })), _polygon273 || (_polygon273 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.47 131.63 138.47 131.93 140.1 132.87 140.1 132.57 138.47 131.63"
  })), _polygon274 || (_polygon274 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.08 135.44 140.35 132.72 140.35 133.01 145.08 135.74 145.08 135.44"
  })), _polygon275 || (_polygon275 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.37 135.5 139.29 133.72 139.29 134.01 142.37 135.79 142.37 135.5"
  })), _polygon276 || (_polygon276 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "145.08 137.06 142.63 135.65 142.63 135.94 145.08 137.36 145.08 137.06"
  })), _polygon277 || (_polygon277 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "144.81 138.52 141.76 136.76 141.76 137.06 144.81 138.82 144.81 138.52"
  })), _polygon278 || (_polygon278 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "143.15 138.1 143.15 138.4 144.81 139.35 144.81 139.06 143.15 138.1"
  })), _polygon279 || (_polygon279 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "138.67 135.52 138.07 135.17 138.07 135.47 138.67 135.81 138.67 135.52"
  })), _polygon280 || (_polygon280 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "139.79 136.16 139.79 136.46 142.9 138.25 142.9 137.96 139.79 136.16"
  })), _polygon281 || (_polygon281 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "139.54 136.02 138.92 135.66 138.92 135.96 139.54 136.31 139.54 136.02"
  })), _polygon282 || (_polygon282 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "142.32 138.16 138.92 136.2 138.92 136.5 142.32 138.46 142.32 138.16"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,79.62l-1.48-.86c-.05-.03-.12-.02-.15.03-.01.02-.02.04-.02.07v1.77c0,.09.05.17.13.21l1.48.86c.05.03.12,0,.15-.05,0-.02.01-.03.01-.05v-1.77c0-.09-.04-.17-.12-.21Z"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,82.27l-1.48-.85c-.05-.03-.12-.02-.15.03-.01.02-.02.04-.02.06v1.77c0,.09.05.17.13.21l1.48.86c.05.03.12,0,.15-.05,0-.02.01-.03.01-.05v-1.76c0-.09-.04-.17-.12-.22Z"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,84.92l-1.48-.85c-.05-.03-.12-.02-.15.03-.01.02-.02.04-.02.06v1.78c0,.09.05.17.13.21l1.48.85s.11.02.14-.02c.02-.02.02-.05.02-.07v-1.77c0-.09-.04-.17-.12-.22Z"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,87.58l-1.48-.86c-.05-.03-.12-.02-.15.03-.01.02-.02.04-.02.07v1.77c0,.09.05.17.13.21l1.48.86c.05.03.12,0,.15-.05,0-.02.01-.03.01-.05v-1.77c0-.09-.04-.17-.12-.21Z"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,90.23l-1.48-.85c-.05-.03-.12-.02-.15.03-.01.02-.02.04-.02.06v1.77c0,.09.05.17.13.21l1.48.86c.05.03.12,0,.15-.05,0-.02.01-.03.01-.05v-1.8c0-.08-.05-.14-.12-.18Z"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,92.88l-1.48-.85c-.05-.03-.12-.02-.15.03-.01.02-.02.04-.02.06v1.78c0,.09.05.17.13.21l1.48.85c.05.03.12,0,.15-.05,0-.01.01-.03.01-.04v-1.77c0-.09-.04-.17-.12-.22Z"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,95.54l-1.48-.86c-.05-.03-.12-.02-.15.03-.01.02-.02.04-.02.07v1.77c0,.09.05.17.13.21l1.48.86c.05.03.12,0,.15-.05,0-.02.01-.03.01-.05v-1.77c0-.09-.04-.17-.12-.21Z"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,98.19l-1.48-.86c-.06-.03-.13,0-.16.06,0,.01,0,.03-.01.04v1.77c0,.09.05.17.13.21l1.48.86c.05.03.12,0,.15-.05,0-.02.01-.03.01-.05v-1.76c0-.09-.04-.18-.12-.22Z"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,100.84l-1.48-.85c-.05-.03-.12-.02-.15.03-.01.02-.02.04-.02.06v1.78c0,.09.05.16.13.2l1.48.86c.05.03.12,0,.15-.05,0-.01.01-.03.01-.04v-1.77c0-.09-.04-.17-.12-.22Z"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,103.5l-1.48-.86c-.05-.03-.12-.02-.15.03-.01.02-.02.04-.02.07v1.77c0,.09.05.17.13.21l1.48.85s.11.02.14-.02c.02-.02.02-.05.02-.07v-1.77c0-.09-.04-.17-.12-.21Z"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,106.15l-1.48-.86c-.05-.03-.12-.02-.15.03-.01.02-.02.04-.02.07v1.77c0,.09.05.17.13.21l1.48.86c.05.03.12,0,.15-.05,0-.02.01-.03.01-.05v-1.72c.02-.1-.03-.21-.12-.26Z"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.6,108.8l-1.48-.85c-.05-.03-.12-.02-.15.03-.01.02-.02.04-.02.06v1.78c0,.09.05.16.13.2l1.48.86c.05.03.12,0,.15-.05,0-.02.01-.03.01-.05v-1.76c0-.09-.04-.17-.12-.22Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "167.19 89.02 167.19 90.09 171.69 92.68 171.69 91.61 167.19 89.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "167.19 90.97 167.19 92.04 171.69 94.64 171.69 93.56 167.19 90.97"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "167.19 92.93 167.19 94 171.69 96.59 171.69 95.52 167.19 92.93"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "201.13 115.53 201.13 114.46 173.38 98.45 173.38 99.52 201.13 115.53"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "167.19 94.88 167.19 95.95 171.69 98.55 171.69 97.48 167.19 94.88"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "167.19 96.84 167.19 97.91 171.69 100.5 171.69 99.43 167.19 96.84"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "201.13 117.48 201.13 116.41 173.38 100.41 173.38 101.47 201.13 117.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "167.19 102.7 167.19 103.78 171.69 106.37 171.69 105.3 167.19 102.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "167.19 104.66 167.19 105.73 171.69 108.32 171.69 107.25 167.19 104.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "167.19 112.48 167.19 113.55 171.69 116.15 171.69 115.08 167.19 112.48"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "167.19 114.44 167.19 115.51 171.69 118.1 171.69 117.03 167.19 114.44"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "190.89 128.1 173.38 118 173.38 119.08 190.89 129.17 190.89 128.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "191.81 128.63 191.81 129.71 201.13 135.08 201.13 134.01 191.81 128.63"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "182.18 121.12 173.38 116.05 173.38 117.12 182.18 122.19 182.18 121.12"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "183.1 121.66 183.1 122.72 201.13 133.13 201.13 132.06 183.1 121.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "198.76 124.82 198.76 125.89 201.13 127.26 201.13 126.19 198.76 124.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "185.85 115.42 173.38 108.23 173.38 109.3 185.85 116.49 185.85 115.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "180.74 96.83 173.38 92.58 173.38 93.65 180.74 97.9 180.74 96.83"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "192.81 103.79 181.66 97.36 181.66 98.43 192.81 104.86 192.81 103.79"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "186.31 102 178.47 97.47 178.47 98.54 186.31 103.07 186.31 102"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "194.54 106.75 187.23 102.53 187.23 103.6 194.54 107.81 194.54 106.75"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "195.46 107.28 195.46 108.35 201.13 111.62 201.13 110.55 195.46 107.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "174.83 97.33 174.83 98.4 180.74 101.81 180.74 100.74 174.83 97.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "198.82 111.17 181.66 101.27 181.66 102.34 198.82 112.24 198.82 111.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "189 111.37 177.78 104.9 177.78 105.97 189 112.44 189 111.37"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "198.82 117.03 189.92 111.9 189.92 112.97 198.82 118.11 198.82 117.03"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "197.84 122.33 186.77 115.95 186.77 117.02 197.84 123.4 197.84 122.33"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "191.81 120.81 191.81 121.88 197.84 125.36 197.84 124.29 191.81 120.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "175.55 111.43 173.38 110.18 173.38 111.25 175.55 112.5 175.55 111.43"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "179.61 113.78 179.61 114.85 190.89 121.35 190.89 120.28 179.61 113.78"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "178.69 113.25 176.47 111.97 176.47 113.04 178.69 114.32 178.69 113.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "188.8 121.03 176.47 113.92 176.47 114.99 188.8 122.1 188.8 121.03"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "208.53 22 208.53 23.07 213.03 25.66 213.03 24.59 208.53 22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "208.53 23.95 208.53 25.02 213.03 27.62 213.03 26.55 208.53 23.95"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "208.53 25.91 208.53 26.98 213.03 29.57 213.03 28.5 208.53 25.91"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "242.47 48.51 242.47 47.44 214.72 31.43 214.72 32.5 242.47 48.51"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "208.53 27.87 208.53 28.94 213.03 31.53 213.03 30.46 208.53 27.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "208.53 29.82 208.53 30.89 213.03 33.49 213.03 32.41 208.53 29.82"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "242.47 50.47 242.47 49.4 214.72 33.39 214.72 34.46 242.47 50.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "208.53 35.69 208.53 36.76 213.03 39.35 213.03 38.28 208.53 35.69"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "208.53 37.64 208.53 38.71 213.03 41.31 213.03 40.24 208.53 37.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "208.53 45.47 208.53 46.54 213.03 49.13 213.03 48.06 208.53 45.47"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "208.53 47.42 208.53 48.49 213.03 51.09 213.03 50.01 208.53 47.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "232.22 61.09 214.72 50.99 214.72 52.06 232.22 62.16 232.22 61.09"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "233.15 61.62 233.15 62.69 242.47 68.07 242.47 67 233.15 61.62"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "223.51 54.11 214.72 49.03 214.72 50.1 223.51 55.18 223.51 54.11"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "224.43 54.64 224.43 55.71 242.47 66.11 242.47 65.04 224.43 54.64"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "240.1 57.8 240.1 58.88 242.47 60.24 242.47 59.17 240.1 57.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "227.19 48.4 214.72 41.21 214.72 42.28 227.19 49.47 227.19 48.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "222.08 29.81 214.72 25.57 214.72 26.64 222.08 30.88 222.08 29.81"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "234.14 36.77 223 30.34 223 31.41 234.14 37.84 234.14 36.77"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "227.65 34.98 219.8 30.46 219.8 31.53 227.65 36.05 227.65 34.98"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "235.88 39.73 228.57 35.51 228.57 36.58 235.88 40.8 235.88 39.73"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "236.8 40.26 236.8 41.33 242.47 44.6 242.47 43.53 236.8 40.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "216.16 30.31 216.16 31.38 222.08 34.79 222.08 33.72 216.16 30.31"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "240.16 44.15 223 34.26 223 35.33 240.16 45.22 240.16 44.15"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "230.33 44.35 219.12 37.88 219.12 38.95 230.33 45.42 230.33 44.35"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "240.16 50.02 231.26 44.88 231.26 45.95 240.16 51.09 240.16 50.02"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "239.17 55.32 228.11 48.94 228.11 50.01 239.17 56.39 239.17 55.32"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "233.15 53.8 233.15 54.87 239.17 58.34 239.17 57.27 233.15 53.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "216.89 44.42 214.72 43.17 214.72 44.24 216.89 45.49 216.89 44.42"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "220.95 46.76 220.95 47.83 232.22 54.34 232.22 53.26 220.95 46.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "220.03 46.23 217.81 44.95 217.81 46.02 220.03 47.3 220.03 46.23"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-38",
    points: "230.14 54.02 217.81 46.91 217.81 47.98 230.14 55.09 230.14 54.02"
  }))), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M127.24,159.41c-1.86-.64-3.92-.33-5.51.84-3,2-5,4.73-3.78,5.75s3.57,2.11,5.1,1.56,9.09-4.99,4.19-8.15Z"
  })), _polygon283 || (_polygon283 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-22",
    points: "190.15 147.74 166.59 161.09 151.57 152.4 175.13 139.06 190.15 147.74"
  })), _polygon284 || (_polygon284 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-35",
    points: "171.2 160.77 171.2 161.29 194.76 147.8 194.76 147.42 171.2 160.77"
  })), _polygon285 || (_polygon285 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "194.76 147.42 171.2 160.77 156.19 152.08 179.74 138.74 194.76 147.42"
  })), _polygon286 || (_polygon286 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "171.2 160.77 171.2 161.29 156.19 152.6 156.19 152.08 171.2 160.77"
  })), _polygon287 || (_polygon287 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "179.58 140.16 188.65 145.39 188.26 145.62 179.18 140.39 179.58 140.16"
  })), _polygon288 || (_polygon288 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "178.64 140.7 187.71 145.93 187.31 146.15 178.24 140.92 178.64 140.7"
  })), _polygon289 || (_polygon289 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "176.45 141.94 188.94 149.15 188.54 149.37 176.05 142.16 176.45 141.94"
  })), _polygon290 || (_polygon290 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "175.58 142.43 188.07 149.64 187.68 149.86 175.18 142.65 175.58 142.43"
  })), _polygon291 || (_polygon291 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "174.72 142.92 187.21 150.13 186.81 150.35 174.32 143.14 174.72 142.92"
  })), _polygon292 || (_polygon292 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "173.85 143.41 186.34 150.62 185.95 150.84 173.46 143.63 173.85 143.41"
  })), _polygon293 || (_polygon293 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "172.99 143.9 185.48 151.11 185.08 151.34 172.59 144.13 172.99 143.9"
  })), _polygon294 || (_polygon294 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "172.12 144.39 184.62 151.6 184.22 151.83 171.73 144.62 172.12 144.39"
  })), _polygon295 || (_polygon295 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "171.26 144.88 183.75 152.09 183.35 152.32 170.86 145.11 171.26 144.88"
  })), _polygon296 || (_polygon296 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "170.39 145.37 182.89 152.58 182.49 152.81 170 145.6 170.39 145.37"
  })), _polygon297 || (_polygon297 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "169.53 145.86 182.02 153.07 181.62 153.3 169.13 146.09 169.53 145.86"
  })), _polygon298 || (_polygon298 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "168.66 146.35 181.16 153.56 180.76 153.79 168.27 146.58 168.66 146.35"
  })), _polygon299 || (_polygon299 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "167.8 146.84 180.29 154.06 179.89 154.28 167.4 147.07 167.8 146.84"
  })), _polygon300 || (_polygon300 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "166.94 147.34 179.43 154.54 179.03 154.77 166.54 147.56 166.94 147.34"
  })), _polygon301 || (_polygon301 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "166.07 147.83 178.56 155.04 178.16 155.26 165.67 148.05 166.07 147.83"
  })), _polygon302 || (_polygon302 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "165.21 148.32 177.7 155.53 177.3 155.75 164.81 148.54 165.21 148.32"
  })), _polygon303 || (_polygon303 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-23",
    points: "164.34 148.81 176.83 156.02 176.44 156.24 163.94 149.03 164.34 148.81"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M154.16,155.51h-2.2v2.38h2.2c.82,0,1.49.67,1.49,1.49v3.86c0,.82-.67,1.48-1.49,1.48h-3.23v2.38h3.23c2.13,0,3.86-1.73,3.87-3.86v-3.83c.01-2.14-1.72-3.89-3.86-3.9,0,0,0,0-.01,0Z"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M153.33,154.2v13.38c0,2.08-3.09,3.76-6.9,3.76s-6.91-1.68-6.91-3.76v-13.38h13.81Z"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M139.52,154.2c0,2.07,3.09,3.76,6.91,3.76s6.9-1.69,6.9-3.76-3.09-3.79-6.9-3.79-6.91,1.72-6.91,3.79Z"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M140.9,154.15c0,1.63,2.47,2.94,5.53,2.94s5.53-1.31,5.53-2.94-2.48-2.93-5.53-2.93-5.53,1.31-5.53,2.93Z"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M146.43,153.14c-2.42,0-4.47.83-5.23,2,.76,1.15,2.81,2,5.23,2s4.47-.83,5.22-2c-.75-1.17-2.8-2-5.22-2Z"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M149.04,157.68v13.38c1.19-.23,2.31-.74,3.25-1.5v-13.38c-.94.76-2.06,1.27-3.25,1.5Z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-38",
    cx: 80.06,
    cy: 206.94,
    rx: 2.01,
    ry: 2.5
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 80.06,
    cy: 206.94,
    rx: 0.81,
    ry: 1.11
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDenim);
export default __webpack_public_path__ + "static/media/denim.46605bbb108139cf3d50438f3ef270b2.svg";
export { ForwardRef as ReactComponent };